module.exports = "//public.zight.com/packs/media/images/4-92f18258a3fce2c4d3cace64aa0d77dd.png";